import React, { useState, useEffect } from 'react'
import Breadcumb from '../../../components/Breadcumb/Breadcumb'
import { Container } from '@material-ui/core'
import { Faqs, Alerts } from '../../../helpers';
import MUIDataTable from "mui-datatables";
import { Link } from 'react-router-dom'
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';

import parse from 'html-react-parser';
const BreadcrumbData = [
  {
    id: 1,
    page_title: "Dashboard",
    page_path: "/",
    icon: "tachometer",
  },
  {
    id: 2,
    page_title: "Faq",
    page_path: "/",
    icon: "tachometer",
  }
]
const FaqsList = () => {
  const [isLoading, setLoading] = useState(true);
  const [faqs, setFaqs] = useState([]);


  const getData = async () => {
    let resp = await Faqs.getFaqs();
    if (resp && resp.status) {
      setFaqs(resp.faqs);
      setLoading(false)
    }
  }
  useEffect(() => {
    getData();
  }, [])

  const deleteFaq = async (id) =>{
    let resp = await Faqs.deleteFaq(id);
    if(resp){
      if(resp.status){
        let faqF = faqs.filter(el=>el.id !== id);
        setFaqs(faqF);
        Alerts.alertMessage(resp.message, '', 'success')
       
      }else{
        Alerts.alertMessage(resp.message, '', 'danger')
      }
    }
    
  }
  const columns = [{
    name: "#SL",
    label: "#SL",
    options: {
      filter: false,
      sort: false
    }
  }, {
    name: "Questions",
    label: "Name",
    options: {
      filter: false,
      sort: false
    }
  }, {
    name: "Answer",
    label: "Answer",
    options: {
      filter: false,
      sort: false
    }
  }
    , "Active",
  {
    name: "Actions",
    label: "Actions",
    options: {
      filter: false,
      sort: false
    }
  },

  ]
  return (
    <>
      <Breadcumb items={BreadcrumbData} />
      <div className="page-wrapper pd30">
        <Container >
         

              <div className='page-inner-header'>
                <h3 className='m-0'>Faq</h3>
                <Link to={`/app/create-faq`} className="btn-primary action-btn">
                  Add New
                </Link>
              </div>

              {
                isLoading ? "Data Loading..." : <MUIDataTable
                  title="Categories"
                  data={faqs.map((item, i) => {

                    return [
                      ++i,
                      item.ques,
                      <div>{parse(item.ans)}</div>,
                      <div>{item.active}</div>,
                      <div className='actions'>
                        <Link to={`/app/faqs/edit/${item.id}`} className=" btn-info action-btn">
                          <EditIcon fontSize="small" />
                        </Link>
                        <button onClick={()=>deleteFaq(item.id)} className=" btn-danger action-btn">
                          <DeleteIcon fontSize="small" />
                        </button>
                      </div>

                    ]
                  })}
                  columns={columns}
                />
              }
           
        </Container>
      </div>

    </>
  )
}

export default FaqsList